import { DescriptionStyled } from './description.styled';
import i18n from '../../../../../translations/strings';
import { Box } from '@mui/material';

const Description = () => {
  return (
    <DescriptionStyled.Container>
      <DescriptionStyled.ContentContainer>
        <DescriptionStyled.Title>
          {i18n.t('landing.titleDescriptionText')}
        </DescriptionStyled.Title>

        <DescriptionStyled.Subtitle>
          {i18n.t('landing.subtitleDescriptionText')}
        </DescriptionStyled.Subtitle>

        {/*<DescriptionStyled.Link to={'/customer/booking'}>*/}
        {/*  <DescriptionStyled.Button variant="text">*/}
        {/*    {i18n.t('landing.reserveNow')}*/}
        {/*  </DescriptionStyled.Button>*/}
        {/*</DescriptionStyled.Link>*/}
      </DescriptionStyled.ContentContainer>
    </DescriptionStyled.Container>
  );
};

export default Description;
